import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Stack } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import appcolors from "../../constants/Colors";
import "./style.css";

function CustomRangePicker({
  stackProps,
  iconProps,
  rangeProps,
  handleDatesChange,
}) {
  const currentYear = moment().year();
  const defaultStartDate = moment(`${currentYear}-01-01`);
  const defaultEndDate = moment(`${currentYear}-12-31`);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [focusedInput, setFocusedInput] = useState(null);

  const onDatesChange = ({ startDate, endDate }) => {
    let dateStart = moment(startDate).format("YYYY-MM-DD");
    let dateEnd = moment(endDate).format("YYYY-MM-DD");

    setStartDate(startDate);
    setEndDate(endDate);
    handleDatesChange(dateStart, dateEnd);
  };

  const handleStackClick = () => {
    setFocusedInput(focusedInput || "startDate");
  };

  return (
    <Stack
      p={"8px"}
      gap={1}
      direction={"row"}
      alignItems={"center"}
      bgcolor={appcolors.white}
      onClick={handleStackClick}
      {...stackProps}
    >
      <CalendarMonthIcon
        htmlColor={appcolors.gunmetal}
        sx={{ fontSize: "1.1rem", ...iconProps }}
      />
      <DateRangePicker
        startDate={startDate}
        startDateId="your_start_date_id"
        endDate={endDate}
        endDateId="your_end_date_id"
        onDatesChange={onDatesChange}
        focusedInput={focusedInput}
        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
        noBorder
        hideKeyboardShortcutsPanel
        customArrowIcon={"-"}
        minimumNights={0}
        isOutsideRange={() => false}
        {...rangeProps}
      />
    </Stack>
  );
}

export default CustomRangePicker;
